import { CustomerAgentStatus } from '../shared/models/customer-agent-status.enum';
import { ApplicationMessageSource } from '../../core/models/application-message-source';
import { MessageType } from '../../core/models/enum/message-type';
import { ApplicationMessage } from '../../core/models/application-message';
import { CustomMessageService } from '../../core/message.service';
import { CustomerAgentDetailsModel } from '../shared/models/customer-agent-details-model';
import { CustomerService } from '../shared/services/customer.service';
import { CustomerModel } from '../shared/models/customer-model';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'hr-customer-edit-agent-list',
  templateUrl: './customer-edit-agent-list.component.html',
  styleUrls: ['./customer-edit-agent-list.component.less'],
  standalone: false,
})
export class CustomerEditAgentListComponent implements OnInit {
  @Input('customer')
  public customer: CustomerModel;
  public resetPassword: string;

  @Output()
  public onEdit: EventEmitter<CustomerAgentDetailsModel> =
    new EventEmitter<CustomerAgentDetailsModel>();
  @Output()
  public onAdd: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output()
  public onStatusUpdate: EventEmitter<boolean> = new EventEmitter<boolean>();

  public customerAgentStatusEnum: CustomerAgentStatus;
  public CustomerAgentStatusEnum: any = CustomerAgentStatus;

  constructor(
    private customerService: CustomerService,
    private translationService: TranslateService,
    private messageService: CustomMessageService
  ) {}

  public onResetPassword(panel, customerAgentId: number, event) {
    this.customerService
      .getTemporaryPassword(customerAgentId)
      .subscribe((result) => {
        this.resetPassword = result.resetPassword;
        panel.toggle(event);
      });
  }

  public onActivationLink(panel2, customerAgentId: number, event) {
    this.customerService
      .getActivationLink(customerAgentId)
      .subscribe((result) => {
        this.customer.activationLink = result.activationLink;
        panel2.toggle(event);
      });
  }

  public clear(event: any) {
    this.resetPassword = null;
  }

  public onEditAgentClick(customerAgent: CustomerAgentDetailsModel) {
    this.onEdit.emit(customerAgent);
  }

  public onAddNewAgent() {
    this.onAdd.emit(true);
  }

  public onActivate(customerAgent: CustomerAgentDetailsModel) {
    if (!confirm(this.translationService.instant('message.AreYouSure'))) {
      return;
    }
    this.customerService.activateAgent(customerAgent).subscribe((result) => {
      this.messageService.pushMessage(<ApplicationMessage>{
        type: MessageType.Success,
        sourceId: ApplicationMessageSource.global,
        summary: '',
        detail: this.translationService.instant('message.SaveMessage'),
      });
      this.onStatusUpdate.emit(true);
    });
  }

  public onDeactivate(customerAgent: CustomerAgentDetailsModel) {
    if (!confirm(this.translationService.instant('message.AreYouSure'))) {
      return;
    }
    this.customerService.deactivateAgent(customerAgent).subscribe((result) => {
      this.messageService.pushMessage(<ApplicationMessage>{
        type: MessageType.Success,
        sourceId: ApplicationMessageSource.global,
        summary: '',
        detail: this.translationService.instant('message.SaveMessage'),
      });
      this.onStatusUpdate.emit(true);
    });
  }

  public onDeleteCustomerAgentClick(customerAgent: CustomerAgentDetailsModel) {
    if (!confirm(this.translationService.instant('message.AreYouSure'))) {
      return;
    }
    this.customerService.deleteAgent(customerAgent).subscribe((result) => {
      let messageType = result.success
        ? MessageType.Success
        : MessageType.Error;
      let messageText: string = this.translationService.instant(
        'message.SaveMessage'
      );

      if (!result.success) {
        messageText = this.translationService.instant(
          'message.' + result.error
        );
      }

      this.messageService.pushMessage(<ApplicationMessage>{
        type: messageType,
        sourceId: ApplicationMessageSource.global,
        summary: '',
        detail: messageText,
      });
      this.onStatusUpdate.emit(true);
    });
  }

  ngOnInit() {}
}
